import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';

export default function RenameFilterModal({
  filter,
  isOpen,
  onSave,
  onClose,
  loading,
}) {
  const [label, setLabel] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen && filter) {
      setLabel(filter.label || '');
      setDescription(filter.description || '');
      setError('');
    }
  }, [isOpen, filter]);

  const handleSave = () => {
    const trimmed = label.trim();
    if (!trimmed) {
      setError('A label is required');
      return;
    }
    onSave({ label: trimmed, description: description.trim() || null });
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="sm">
      <ModalHeader
        toggle={onClose}
        style={{ borderBottom: '2px solid #f96332' }}
      >
        Rename Filter
      </ModalHeader>
      <ModalBody style={{ padding: '20px 24px' }}>
        <FormGroup>
          <Label className="fb-label">
            Label <span style={{ color: '#e74c3c' }}>*</span>
          </Label>
          <Input
            type="text"
            value={label}
            onChange={(e) => {
              setLabel(e.target.value);
              setError('');
            }}
            invalid={!!error}
            autoFocus
            disabled={loading}
          />
          {error && <div className="fb-error">{error}</div>}
        </FormGroup>
        <FormGroup>
          <Label className="fb-label">
            Description{' '}
            <small className="text-muted" style={{ fontWeight: 400 }}>
              (optional)
            </small>
          </Label>
          <Input
            type="text"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Short note about this filter"
            disabled={loading}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter style={{ borderTop: '1px solid #e3e3e3' }}>
        <Button
          color="secondary"
          outline
          size="sm"
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          size="sm"
          onClick={handleSave}
          disabled={loading}
          style={{
            backgroundColor: '#f96332',
            borderColor: '#f96332',
            color: '#fff',
          }}
        >
          {loading ? 'Saving…' : 'Save'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
